import React from 'react';
import Staad1 from "../assets/img/pageimages/Staad1.jpg";
import Staad2 from "../assets/img/pageimages/Staad2.webp";
import Staad3 from "../assets/img/pageimages/Staad3.jpg";

function Staad() {
  return (
    <div className="staad-wrapper">
      <style>{`
        .staad-wrapper {
          background: linear-gradient(to right, #eef2ff, #e0e7ff);
          min-height: 100vh;
          color: #1f2937;
          font-family: 'Segoe UI', sans-serif;
          padding: 2rem 1rem;
        }

        .staad-header {
          background: linear-gradient(to right, #4f46e5, #3730a3);
          color: white;
          border-radius: 1rem;
          padding: 3rem 2rem;
          text-align: center;
          max-width: 900px;
          margin: 0 auto;
          box-shadow: 0 15px 30px rgba(0,0,0,0.1);
        }

        .staad-header h1 {
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 1rem;
          text-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }

        .staad-header p {
          font-size: 1.125rem;
          line-height: 1.75;
          max-width: 700px;
          margin: 0 auto;
        }

        .staad-main {
          margin-top: 4rem;
          max-width: 1100px;
          margin-left: auto;
          margin-right: auto;
          display: flex;
          flex-direction: column;
          gap: 3rem;
          padding: 0 1rem;
        }

        @media (min-width: 768px) {
          .staad-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 2.5rem;
          }
        }

        .staad-box {
          background: white;
          padding: 2rem;
          border-radius: 1rem;
          box-shadow: 0 10px 20px rgba(0,0,0,0.05);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .staad-box:hover {
          transform: scale(1.02);
          box-shadow: 0 20px 35px rgba(0,0,0,0.08);
        }

        .staad-title {
          font-size: 1.5rem;
          font-weight: 600;
          margin-bottom: 1.5rem;
          text-shadow: 0 1px 2px rgba(0,0,0,0.05);
        }

        .text-indigo {
          color: #4338ca;
        }

        .text-green {
          color: #059669;
        }

        .staad-box ul {
          padding-left: 1.25rem;
          list-style-type: disc;
          font-size: 1rem;
          color: #374151;
          line-height: 1.75;
        }

        .staad-conclusion {
          text-align: center;
          font-size: 1.125rem;
          line-height: 1.8;
          color: #374151;
          max-width: 700px;
          margin: 0 auto;
        }

        /* Image Section Styles */
        .staad-images {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 2rem;
          margin-top: 3rem;
        }

        .staad-images img {
          width: 300px;
          max-width: 100%;
          height: auto;
          border-radius: 1rem;
          box-shadow: 0 8px 20px rgba(0,0,0,0.08);
          transition: transform 0.3s ease;
          object-fit: cover;
        }

        .staad-images img:hover {
          transform: scale(1.03);
        }
      `}</style>

      {/* Header Section */}
      <header className="staad-header">
        <h1>STAAD Pro</h1>
        <p>
          STAAD Pro is a structural analysis and design software widely used in civil engineering for designing buildings, bridges, and other structures. It allows engineers to model, analyze, and design structures in a variety of materials such as steel, concrete, and wood.
        </p>
      </header>

      {/* Main Content */}
      <main className="staad-main">
        <section className="staad-grid">
          {/* Features */}
          <div className="staad-box">
            <h2 className="staad-title text-indigo">Key Features:</h2>
            <ul>
              <li>Advanced Analysis Capabilities (Linear and Non-Linear)</li>
              <li>3D Structural Modeling</li>
              <li>International Design Codes Support</li>
              <li>Seismic Analysis</li>
              <li>Integration with CAD Software</li>
            </ul>
          </div>

          {/* Applications */}
          <div className="staad-box" style={{ background: '#f9fafb' }}>
            <h2 className="staad-title text-green">Applications:</h2>
            <ul>
              <li>Residential and Commercial Buildings</li>
              <li>Bridges</li>
              <li>Industrial Structures</li>
              <li>Offshore Platforms</li>
            </ul>
          </div>
        </section>

        {/* Images Section */}
        <section className="staad-images">
          <img src={Staad1} alt="STAAD Pro Example 1" />
          <img src={Staad2} alt="STAAD Pro Example 2" />
          <img src={Staad3} alt="STAAD Pro Example 3" />
        </section>

        {/* Conclusion */}
        <section className="staad-box">
          <p className="staad-conclusion">
            STAAD Pro is known for its robust capabilities, ease of use, and comprehensive design checks, making it a popular choice for structural engineers worldwide.
          </p>
        </section>
      </main>
    </div>
  );
}

export default Staad;
